/**
 * دالة طباعة كشف الحساب - نموذج HTML منفصل
 * هذا الحل يفتح نافذة جديدة بـ HTML بسيط بدون أي تعقيدات CSS
 */

export const printAccountStatement = (data) => {
  const {
    accountName,
    accountNumber,
    accountBalance,
    initialBalance = 0,
    startDate,
    endDate,
    transactions,
    totals
  } = data;

  // إنشاء HTML للطباعة
  const printHTML = `
<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="UTF-8">
  <title>كشف حساب - ${accountName}</title>
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-size: 14px;
      line-height: 1.6;
      padding: 20px;
      direction: rtl;
    }
    
    .header {
      text-align: center;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 3px solid #333;
    }
    
    .header h1 {
      font-size: 24px;
      margin-bottom: 10px;
      color: #333;
    }
    
    .header p {
      font-size: 14px;
      color: #666;
      margin: 5px 0;
    }
    
    .summary {
      display: flex;
      justify-content: space-around;
      margin: 20px 0;
      padding: 15px;
      background: #f5f5f5;
      border: 2px solid #ddd;
      border-radius: 5px;
    }
    
    .summary-item {
      text-align: center;
    }
    
    .summary-label {
      font-size: 12px;
      color: #666;
      margin-bottom: 5px;
    }
    
    .summary-value {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
    
    table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
      font-size: 13px;
    }
    
    th, td {
      border: 1px solid #333;
      padding: 10px 8px;
      text-align: right;
    }
    
    th {
      background: #e0e0e0;
      font-weight: bold;
      font-size: 14px;
    }
    
    .number {
      text-align: left;
      direction: ltr;
      font-family: 'Courier New', monospace;
    }
    
    .footer {
      margin-top: 30px;
      padding-top: 15px;
      border-top: 2px solid #333;
      text-align: center;
      font-size: 12px;
      color: #666;
    }
    
    @media print {
      body {
        padding: 10px;
      }
    }
  </style>
</head>
<body>
  <div class="header">
    <h1>كشف حساب: ${accountName}</h1>
    <p>رقم الحساب: ${accountNumber}</p>
    <p>الفترة: من ${startDate} إلى ${endDate}</p>
    <p>تاريخ الطباعة: ${new Date().toLocaleDateString('ar-SA')} ${new Date().toLocaleTimeString('ar-SA')}</p>
  </div>
  
  <div class="summary">
    <div class="summary-item">
      <div class="summary-label">الرصيد الابتدائي</div>
      <div class="summary-value" style="color: #0288d1;">${initialBalance.toLocaleString()} ريال</div>
    </div>
    <div class="summary-item">
      <div class="summary-label">إجمالي المدين</div>
      <div class="summary-value" style="color: #388e3c;">${totals.totalDebit.toLocaleString()} ريال</div>
    </div>
    <div class="summary-item">
      <div class="summary-label">إجمالي الدائن</div>
      <div class="summary-value" style="color: #d32f2f;">${totals.totalCredit.toLocaleString()} ريال</div>
    </div>
    <div class="summary-item">
      <div class="summary-label">الرصيد الحالي</div>
      <div class="summary-value" style="color: #1976d2;">${accountBalance.toLocaleString()} ريال</div>
    </div>
  </div>
  
  <table>
    <thead>
      <tr>
        <th style="width: 8%;">رقم المعاملة</th>
        <th style="width: 10%;">التاريخ</th>
        <th style="width: 25%;">الوصف</th>
        <th style="width: 10%;">المرجع</th>
        <th style="width: 12%;">مدين</th>
        <th style="width: 12%;">دائن</th>
        <th style="width: 12%;">الرصيد</th>
        <th style="width: 11%;">الملاحظات</th>
      </tr>
    </thead>
    <tbody>
      ${transactions.map(t => `
        <tr>
          <td class="number">${t.sequentialId || '-'}</td>
          <td>${new Date(t.date).toLocaleDateString('ar-SA')}</td>
          <td>${t.description || '-'}</td>
          <td>${t.referenceNumber || '-'}</td>
          <td class="number">${t.debit > 0 ? t.debit.toLocaleString() : '-'}</td>
          <td class="number">${t.credit > 0 ? t.credit.toLocaleString() : '-'}</td>
          <td class="number"><strong>${t.balance.toLocaleString()}</strong></td>
          <td>${t.notes || '-'}</td>
        </tr>
      `).join('')}
    </tbody>
  </table>
  
  <div class="footer">
    <p>تم طباعة ${transactions.length} معاملة</p>
    <p>هذا الكشف تم إنشاؤه آلياً من النظام</p>
  </div>
  
  <script>
    // طباعة تلقائية عند فتح النافذة
    window.onload = function() {
      window.print();
    };
  </script>
</body>
</html>
  `;

  // فتح نافذة جديدة
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  
  if (printWindow) {
    printWindow.document.write(printHTML);
    printWindow.document.close();
  } else {
    alert('يرجى السماح بفتح النوافذ المنبثقة لطباعة كشف الحساب');
  }
};